import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeDifference',
  standalone: true
})
export class TimeDifferencePipe implements PipeTransform {
  transform(dateStart: string, dateEnd: string): string {
    if (!dateStart || !dateEnd) return "00:00";

    const startDate = new Date(dateStart);
    const endDate = new Date(dateEnd);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return "00:00";
    }

    const diffInMs = endDate.getTime() - startDate.getTime();
    if (diffInMs < 0) return "00:00"; // Si la fecha de inicio es mayor, retorna 00:00

    const hours = Math.floor(diffInMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${hours} h ${minutes} m`;
  }
}
